import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APIResponse } from '@mommy/models/Comm.model';
import { Api } from '../api';
import { HANDLE_CACHE } from '../token.interceptor';
const fs = require('fs');

@Injectable({
  providedIn: 'root',
})
export class MaternityKitService {
  constructor(private api: Api) {
    console.log('Hello MaternityKitService');
  }

  getAllMaternityKit(force?: boolean): Promise<any> {
    const endpoint = `v1/codes/reference-codes/all-maternitykits`;

    return new Promise(async (resolve, reject) => {
      try {
        const context = new HttpContext();
        context.set(HANDLE_CACHE, force ? false : true);

        const result: APIResponse = (await this.api
          .get(endpoint, null, { context })
          .toPromise()) as any;
        console.log('result', result);
        if (result.returnCode === 'ERROR') {
          reject(result);
        } else {
          resolve(result.data);
        }
      } catch (error) {
        if (error?.status !== 304) {
          console.error('getAllMaternityKit error', error);
        }
        reject(error);
      }
    });
  }

  getAllMaternityKitAtServer(): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        // 先從檔案讀取, 若無, 則呼叫 api 取得 並儲存到檔案
        const filename = 'cache-all-maternitykits.json';
        const filepath = `./${filename}`;

        console.log('@Server: getAllMaternityKitAtServer filepath', filepath);
        fs.readFile(filepath, 'utf8', async (err, data) => {
          if (err) {
            console.error('@Server: getAllMaternityKitAtServer error', err);
            reject(err);
          }

          if (data) {
            const data_obj = JSON.parse(data);
            console.log(
              '@Server: getAllMaternityKitAtServer got cache data, rows: ',
              data_obj?.length
            );
            resolve(data_obj);
          } else {
            console.log(
              '@Server: getAllMaternityKitAtServer got no cache, call api to get data'
            );
            const new_data = await this.getAllMaternityKit();
            fs.writeFile(filepath, JSON.stringify(new_data), (err) => {
              if (err) {
                console.error('@Server: getAllMaternityKitAtServer error', err);
                reject(err);
              }

              console.log(
                '@Server: getAllMaternityKitAtServer save cache success'
              );
              resolve(new_data);
            });
          }
        });
      } catch (error) {
        reject(error);
      }
    });
  }
}
